// vendors
import { Title, } from '@mantine/core';

// utils

export default function PageHeading({ children }) {

    return (
        <>
            <Title
                order={1}
                sx={{
                    fontWeight: 'lighter',
                    fontSize: '1.5rem'
                }}
                mb='md'
            >
                {children}
            </Title>

        </>
    )

}